// @ts-nocheck
import { useEffect, useState } from "react";
import { useTheme } from "styled-components";

export default () => {
    const theme = useTheme();
    const { values } = theme.breakpoints;
    const [currentBreakpoint, setCurrentBreakpoint] = useState<number>(0);
    const [width, setWidth] = useState<number>();

    useEffect(() => {
        setWidth(document?.documentElement?.clientWidth);
    }, []);

    useEffect(() => {
        window.addEventListener("resize", onResizeHandler);

        return () => {
            window.removeEventListener("resize", onResizeHandler);
        };
    }, []);

    useEffect(() => {
        if (width) {
            let breakpointIndex;

            if (width > values[values.length - 1]) {
                setCurrentBreakpoint(values.length - 1);
                return;
            }

            for (const [i, x] of values.entries()) {
                if (x > width) {
                    breakpointIndex = i - 1;
                    break;
                }
            }

            if (breakpointIndex) {
                setCurrentBreakpoint(breakpointIndex);
            }
        }
    }, [width]);

    const onResizeHandler = () => {
        setWidth(document?.documentElement?.clientWidth);
    };

    return currentBreakpoint;
};
